import { useCuttingStore } from './state/useCuttingStore';
import { DEFAULT_MIN_OFFCUT_MM } from './lib/resultMetrics';
import { buildOffcutList } from './lib/offcutList';

/**
 * Block 14 «Раскрой» — таблица «Список остатков» (экран + печать).
 *
 * Показывает годные новые остатки текущего результата (те же `freeRects`, что
 * рисуются «остаток Д × Ш» на карте; `isUsableOffcut`, общий порог). Номера `ОN`
 * совпадают с углами кусков на карте (общий источник — `buildOffcutList`).
 *
 * Размещение в `.cutting-print-region` через flex-`order` (cutting-theme.css):
 *  • Экран: order 4 — ПОД картой (`CutMap`/пейджер); видна (не `.cut-print-only`).
 *  • Печать: order 4 — ПОСЛЕ «Список деталей» (`CutPrintDetails`, order 3).
 * Переиспользует классы `.cut-print-details-table`/`-title` (центрированная таблица,
 * идентично «Список деталей»). Пустой кейс (нет годных остатков) → `null`.
 *
 * 5 состояний (P-021): как `CutMap` — при `cutStatus !== 'success'`/нет результата
 * возвращает `null`; stub отдаёт соседний `ResultsTab`.
 */
export function CutOffcutList() {
  const lastResult = useCuttingStore((s) => s.lastResult);
  const cutStatus = useCuttingStore((s) => s.cutStatus);
  const minOffcutSize = useCuttingStore((s) => s.document.settings.minOffcutSize);

  if (cutStatus !== 'success' || !lastResult) return null;

  const threshold = minOffcutSize ?? DEFAULT_MIN_OFFCUT_MM;
  const { rows } = buildOffcutList(lastResult, threshold);
  if (rows.length === 0) return null; // нет годных остатков → таблицу не показываем

  return (
    <div className="cut-offcut-list" data-testid="cut-offcut-list">
      <div className="cut-print-details-title">Список остатков</div>
      <table className="cut-print-details-table">
        <thead>
          <tr>
            <th>№</th>
            <th>Размер</th>
            <th>Площадь, м²</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.number}>
              <td>О{r.number}</td>
              <td>
                {r.length} × {r.width}
              </td>
              <td>{r.areaM2.toFixed(3)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
